import { generatePath } from 'react-router-dom';
import { Paperclip } from 'lucide-react';

import { SiteMetadata } from '@/api/fe-api/domain/entities/site-metadata';
import { Link } from '@/components/ui/link';

export type SiteMetadataSourcesProps = {
  documents: SiteMetadata.Document[];
  documentIndexes: Record<string, number>;
  siteId: string;
};

export function SiteMetadataSources({
  documents,
  documentIndexes,
  siteId,
}: SiteMetadataSourcesProps) {
  return (
    <div>
      <h4 className="mb-2 block text-xl font-medium leading-6 text-gray-900">
        Sources
      </h4>
      <div className="flex flex-col gap-3">
        {documents.map((document) => (
          <Link
            key={document.id}
            id={`source-${document.id}`}
            to={generatePath('/asset/:siteId/documents?id=:documentId', {
              siteId,
              documentId: document.id,
            })}
          >
            <div className="flex w-full items-center gap-4 rounded p-4 ring-0 ring-primary-200 transition-shadow duration-500 hover:bg-stone-100">
              <Paperclip className="size-5 text-stone-400" />
              <div>
                <span className="mr-2 text-stone-400">
                  {documentIndexes[document.id] + 1}.
                </span>
                {document.name}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
